import { cutToast } from 'utility/toast';
import React from 'react';
import { BlockBlobClient } from '@azure/storage-blob';
import { useMutation } from '@apollo/client';

import { UploadFiles } from 'common/components/UploadFiles';
import { DocumentTypeOption } from 'common/components/UploadFiles/view';
import { SupplierAvailableDocumentTypes } from '../__generated__/SupplierAvailableDocumentTypes';
import { Supplier_supplier } from '../../../__generated__/Supplier';
import {
  SupplierUploadDocument,
  SupplierUploadDocumentVariables,
  SupplierUploadDocument_supplierUploadDocument,
} from './__generated__/SupplierUploadDocument';
import PAYCYCLE_UPLOAD_DOCUMENT from './SupplierUploadDocument.graphql';
import { useFormContext } from 'react-hook-form';
interface UploadFormProps {
  availableDocumentTypes: SupplierAvailableDocumentTypes | undefined;
  supplier?: Supplier_supplier;
  onUpload?: (
    fileSelected: File,
    documentData: SupplierUploadDocument_supplierUploadDocument,
    toastId: string
  ) => void;
}
export const UploadForm: React.FC<UploadFormProps> = ({
  availableDocumentTypes,
  supplier,
  onUpload,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext();

  const [uploadDocument] = useMutation<
    SupplierUploadDocument,
    SupplierUploadDocumentVariables
  >(PAYCYCLE_UPLOAD_DOCUMENT, { errorPolicy: 'all' });

  const { isDraft, id } = { ...supplier };
  const documentTypeOptions =
    availableDocumentTypes?.supplierAvailableDocumentTypes?.nodes.map(
      (doctype) =>
        ({
          key: doctype.id,
          text: doctype.documentType || '',
          isAccountingDocument: doctype.isAccountingDocument,
          title:
            isDraft && doctype.isAccountingDocument
              ? 'Upload prohibited during/after the approval process'
              : undefined,
          disabled: (!isDraft && doctype.isAccountingDocument) || undefined,
        }) as DocumentTypeOption
    ) || [];
  return (
    <UploadFiles
      documentTypes={documentTypeOptions!}
      uploadDocument={{
        uploadDocumentData: async (documentType, data, filSelected) => {
          filSelected.map(async (fileEntity, fileIndex) => {
            //const toastId = `file.name.${fileEntity?.name}.${fileIndex}`;
            const toastId = cutToast.info(`Uploading ${fileEntity?.name}...`);
            const uploadMutationResults = await uploadDocument({
              variables: {
                document: {
                  ...data,
                  documentTypeId: parseInt(documentType.key.toString()),
                  filename: fileEntity.name,
                },
                supplierId: id!,
              },
            });
            if (uploadMutationResults.errors) {
              cutToast.error(`Upload of ${fileEntity.name} failed`, {
                id: toastId,
              });
            }
            if (
              uploadMutationResults.data?.supplierUploadDocument?.document &&
              uploadMutationResults.data.supplierUploadDocument?.document
                ._documentFileId
            ) {
              onUpload?.(
                fileEntity,
                uploadMutationResults.data.supplierUploadDocument,
                toastId!
              );
              const client = new BlockBlobClient(
                uploadMutationResults.data.supplierUploadDocument?.uploadLink
              );
              await client.uploadData(fileEntity);
            }
          });
        },
      }}
      disableUpload={isDirty}
    />
  );
};
